import React, { useState, useEffect } from 'react';
import { requestCurrentVersion } from '../features/version/data/versionSlice';
import { faCircleExclamation, faSignalStream, faSignalStreamSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Badge from 'react-bootstrap/Badge';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import VersionUpdateModal from './VersionUpdateModal';
import { useTypedDispatch, useTypedSelector } from "../app/typedHooks";

const Footer = (): JSX.Element => {
    const dispatch = useTypedDispatch();

    const [ updateModalDismissed, setUpdateModalDismissed ] = useState(false);
    const { isConnected, requiresUpdate, apiVersion, clientVersion, isLoading, isLoaded } = useTypedSelector(state => state.version);

    useEffect(() => {
        if (!isLoading && !isLoaded) {
          dispatch(requestCurrentVersion());
        }
      }, [isLoading, isLoaded]);

    const getVersionStatusComponent = () => {
        if(requiresUpdate === true) {
            return <FontAwesomeIcon className="text-danger" icon={faCircleExclamation} onClick={() => setUpdateModalDismissed(false)} />    
        } else {
            return <React.Fragment/>
        }
    }

    const getConnectionStatusComponent = () => {
        if(isConnected) {
            return <FontAwesomeIcon icon={faSignalStream} className="ms-1" />
        } else {
            return <FontAwesomeIcon icon={faSignalStreamSlash} className="ms-1" />
        }
    }


    if(apiVersion === undefined) {
        return (<div className="container"></div>);
    }

    let badgeClass: string = "danger";

    if(apiVersion.environment.endsWith('prod')){
        badgeClass = "success";
    }
    else if(apiVersion.environment.endsWith('test') || apiVersion.environment.endsWith('qa')) {
        badgeClass = "warning";
    }

    return (
        <footer className="footer py-1 bg-white shadow">
            <Container fluid>
                <Row>
                    <Col xs={4} sm={3}>
                        <small>{clientVersion.version} {getVersionStatusComponent()}</small>
                    </Col>
                    <Col sm={6} className="text-center d-none d-sm-block">
                        Service Automation Framework<br/>
                        <small className="text-muted">{apiVersion.assemblyName.replace(/([A-Z])/g, ' $1')}</small>
                    </Col>
                    <Col xs={4} className="text-center d-block d-sm-none">
                        <small>SAF - {apiVersion.assemblyName.replace(/([A-Z])/g, ' $1')}</small>
                    </Col>
                    <Col xs={4} sm={3} className="text-end">
                        <Badge bg={badgeClass} className="me-1">{apiVersion.environment}{getConnectionStatusComponent()}</Badge>
                    </Col>
                </Row>
            </Container>
            <VersionUpdateModal 
                showModal={requiresUpdate && !updateModalDismissed}
                dismissModal={() => setUpdateModalDismissed(true)}
                clientVersion={clientVersion}
                apiVersion={apiVersion} />
        </footer>
    );
    
}

export default Footer;